import { AdgroupFormData, BidStrategyType, CampaignFormData, StrategyListItem } from '@tt4b/ttam-enums';
import { useStdAdgroupCbo } from '@tt4b/ttam-hooks';
import { Ref, computed, ref } from '@vue/composition-api';
import { getCurrentLang } from '@tt4b/ttam-utils';
import { allStrategies } from '../consts';

export function useStrategyTooltipPropsVisible(props: {
  adgroupData: Ref<AdgroupFormData>;
  campaignData: Ref<CampaignFormData>;
}) {
  const { campaignData, adgroupData } = props;
  const { isCBOVO } = useStdAdgroupCbo({
    adgroupFormData: adgroupData,
    campaignFormData: campaignData,
  });

  return {
    visible: computed(() => !isCBOVO.value || adgroupData.value.roasBid),
  };
}

export function useStrategyTooltipPropsStrategyType(campaignData: Ref<CampaignFormData>) {
  const strategyType = computed(() => allStrategies(campaignData).find(it => it.type === BidStrategyType.MIN_ROAS));

  return {
    strategyType,
  };
}

export function useStrategyTooltipPropsDisabled(props: { toolTipsDisabled: Ref<boolean> }) {
  return {
    disabled: (item: StrategyListItem) => item.type !== BidStrategyType.HIGHEST_VALUE || props?.toolTipsDisabled?.value,
  };
}

export function useGetImageUrl(type: BidStrategyType): string {
  const currentLang = ref(getCurrentLang());
  const nameMap = {
    [BidStrategyType.BID_CAP]: 'bidcap',
    [BidStrategyType.COST_CAP]: 'costcap',
    [BidStrategyType.LOWEST_COST]: 'lowestcost',
    [BidStrategyType.MAXCV]: 'maxcv',
    [BidStrategyType.HIGHEST_VALUE]: 'highestvalue',
    [BidStrategyType.MIN_ROAS]: 'roas',
  };

  const supportLang = ['zh', 'ja', 'en'];
  if (supportLang.includes(currentLang.value)) {
    return `./bid-${nameMap[type]}-${currentLang.value}.png`;
  }

  return `./bid-${nameMap[type]}-en.png`;
}
